import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { DuelText, RoundAvatar } from "..";
import { Anchor } from "../elements";
import { LogoutConfirmModal } from "../sidebar";

export function ProfileDropdown({ name, username, image, dropdown }) {
  const [showLogout, setShowLogout] = useState(false);
  return (
    <Dropdown className="mc-header-user">
      <Dropdown.Toggle className="mc-dropdown-toggle">
        {/* <RoundAvatar src={ image } alt="avatar" size="xs" /> */}
        <DuelText title={name} descrip={username} size="xs" />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="mc-dropdown-paper">
        {dropdown.map((item, index) =>
          item.logout ? (
            <Anchor
              key={index}
              icon={item.icon}
              text={item.text}
              className="mc-dropdown-menu"
              onClick={(e) => {
                e.preventDefault();
                setShowLogout(true);
              }}
            />
          ) : (
            <Anchor key={index} href={item.path} icon={item.icon} text={item.text} className="mc-dropdown-menu" />
          ),
        )}
      </Dropdown.Menu>
      <LogoutConfirmModal open={showLogout} onClose={() => setShowLogout(false)} />
    </Dropdown>
  );
}
